<template>
    <label :for="'input-'+name" class="bbox-text-input-label" :class="{'has-error': !!error}">
        <span :class="[labelClassesToApply,'label']" v-if="!$slots.label && !!label">{{ label }}</span>
        <slot name="label"/>
        <div class="input-wrapper" :class="{autosize}">
            <span class="icon-left" v-if="$slots['icon-left']"><slot name="icon-left"/></span>
            <span class="icon-right" v-if="$slots['icon-right']"><slot name="icon-right"/></span>
            <input ref="input" class="bbox-text-input" :class="[inputClassesToApply,{'has-icon-left': !!$slots['icon-left'], 'has-icon-right': !!$slots['icon-right']}]" :type="type" :id="'input-'+name" :value="value" :name="name" @change="($event) => {$emit('change', $event.target.value);}" @input="($event) => {$emit('input', $event.target.value);updateSize()}" :placeholder="placeholder">
        </div>
        <span class="input-error red-base margin-top-tiny" v-if="!!error">{{ error }}</span>
    </label>
</template>

<script>
export default {
    name: 'BTextInput',
    props: {
        inputClasses: {
          type: String,
          default: "font-size-big ink-base placeholder-ink-lighter-2 padding-normal border border-ink-lighter-3 border-focus-ink-lighter-1  bg-white-darker-2 bg-focus-white-darker-3"
        },
        inputErrorClasses: {
          type: String,
          default: "font-size-big red-base placeholder-red-lighter-2 padding-normal border border-red-lighter-2 border-focus-red-base  bg-red-lighter-4 bg-focus-red-lighter-3"
        },
        labelClasses: {
          type: String,
          default: "font-size-big ink-base semi-bold margin-bottom-normal"
        },
        labelErrorClasses: {
          type: String,
          default: "font-size-big ink-base semi-bold margin-bottom-normal"
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Digite aqui...'
        },
        error: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text',
            validator(val) {
                return val === 'text' || val === 'password' || val === 'number' || val === 'email';
            }
        },
        autosize: Boolean
    },
    computed: {
      inputClassesToApply() {
        if(this.error) return this.inputErrorClasses;
        else return this.inputClasses;
      },
      labelClassesToApply() {
        if(this.error) return this.labelErrorClasses;
        else return this.labelClasses;
      }
    },
    methods: {
        updateSize() {
            if(this.autosize) {
                this.$refs.input.style.width = '0px';
                var realWidth = this.$refs.input.scrollWidth;
                this.$refs.input.style.width = (realWidth+2)+'px';
            }
        }
    },
    mounted() {
        this.updateSize();
    },
    updated() {
        this.updateSize();
    }
}
</script>

<style scoped lang="scss">
    label, label * {
        box-sizing: border-box;
    }
    .input-wrapper {
        position: relative;
        width: 100%;
        display: inline-block; //to counter margin merging
        &.autosize {
            width: auto;
            display: inline-block;
            input {
                width: auto;
            }
        }
    }
    input {
        border-radius: 5px;
        display: block;
        width: 100%;
        position: relative;
        z-index: 1;
        outline: none;
    }
    span.icon-left {
        position: absolute;
        left: 1.3125rem;
        top: calc(0.8125rem + 0.05em);
        color: #8F8A9B;
        z-index: 2;
    }
    span.icon-right {
        position: absolute;
        top: calc(0.8125rem + 0.05em);
        right: 1.3125rem;
        color: #8F8A9B;
        z-index: 2;
    }
    input.has-icon-left {
        padding-left: calc(2.625rem + 0.8em);
    }
    input.has-icon-right {
        padding-right: calc(2.625rem + 0.8em);
    }
    span.input-error {
        display: block;
        text-align: left;
        line-height: 1;
    }
    label span.label {
        display: block;
        text-align: left;
    }
</style>

<docs>
    BInput
    ```js 
    <b-text-input autosize />
    ```
</docs>
